import { gql } from '@apollo/client';

export const SYNC_TOTAL_LIEN_BALANCE_TO_SALESFORCE = gql`
  mutation SyncTotalLienBalanceToSalesforce($trackId: IdentifierType!) {
    syncTotalLienBalanceToSalesforce(trackId: $trackId) {
      ok
    }
  }
`;
